var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cpan_wrapper"}},[_c('core-toolbar',{staticStyle:{"z-index":"100"},attrs:{"drawer":_vm.drawer},on:{"toggle-drawer":_vm.toggleDrawer}}),_c('router-view',{attrs:{"name":"router_wrapper_kitchen"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }